import { nextTick } from 'vue';

import Cookies from 'js-cookie';

import router from '@/router/index';
import store from '@/store';
import { getToken } from './utils/auth';
import utility from "@/utils/utility"
import NProgress from 'nprogress'; // 进度条

import i18n from '@/lang'; // Internationalization

import { loadCompanyTheme } from '@/utils/theme';

import Message from '@/components/message/message';
let msgBox = Message.install;

const whiteList = [
	/^\/login$/,
	/^\/404$/,
	/^\/index(?:\/[^\/]+){0,2}$/,//三个就是0,3
	/^\/invoice(?:\/[^\/]+){0,1}$/,//三个就是0,3
]; // 不重定向白名单

router.beforeEach((to, from, next) => {

	NProgress.start();
	document.getElementById('app')?.scrollTo(0, 0)

	const flag = process.env.BASE_FLAG;
	let company;
	
	// 动态设置 i18n 语言
	if(flag=='qjt'){
		company = to.params.company === 'zc' ? 'zc' : 'qjt';  // 获取公司标识
	}else{
		company = to.params.company === 'qjt' ? 'qjt' : 'zc';  // 获取公司标识
	}

	// 设置favicon
	utility.changeFavicon(`/static/icon/${company}.png`);

	i18n.global.locale = company;  // 设置 i18n 的 locale
  	loadCompanyTheme(company);// 切换主体颜色
  	
	store.dispatch(`SetCompany`,company);
	// 判空一下 不然会导致在别的路由下 由于activeNav不存在导致跳转到index/intro
	if(to.params.activeNav) {
	  store.dispatch('SetActiveNav',to.params.activeNav);
	}

	if (getToken()) {
		if (to.path === '/login') {
			next({
				path: '/',
			});
			NProgress.done();
		} else {
			next();
			store.dispatch('GetUserInfo').then(res => {
				next();
			})
			.catch(err => {
				store.dispatch('FedLogOut').then(() => {
					msgBox({
						content: 'TOKEN_ERROR',
						// content: i18n.vm.messages[i18n.locale]['BACKENDMSG']['TOKEN_ERROR'],
						timeOut: 2000,
						isClose: false,
						type: 'error',
					});
					next({
						path: '/index',
					});
				});
			});
		}
	} else {
		// 使用正则匹配路径来判定是否在白名单中
		let isInWhiteList = whiteList.some(pattern => pattern.test(to.path));
		if(isInWhiteList) { // 在免登录白名单，直接进入
			next();
		}else{
			next(`/index/${company}`) // 否则全部重定向到登录页
			NProgress.done();
		}
	}
});

router.afterEach(() => {
	document.querySelector('.home-container')?.scrollTo(0, 0);
	document.title = i18n.global.t('company');
	NProgress.done(); // 结束Progress
});
